import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InlineLoader from 'components/_core/InlineLoader';
import Message from 'components/_core/Message';
import { fetchCurriculum } from 'redux/actions';

const CurriculumFetcher = (
    {
        children
    }
) => {
    const dispatch = useDispatch();
    const fetched = useSelector(state => state.courseList.curriculum.fetched);
    const error = useSelector(state => state.courseList.curriculum.error);

    useEffect(() => {
        dispatch(fetchCurriculum());
    }, [dispatch])

    if (error) {
        return (
            <Message heading="Error loading curriculum" error noIcon small>
                Refresh the page to try again.
            </Message>
        );
    }

    if (!fetched) {
        return <InlineLoader />;
    }

    return children;
};

export default CurriculumFetcher;
